<div class="container">
  <mat-card>
    <mat-card-header>
      <div class="page-title">SMS Sender</div>
    </mat-card-header>
    <mat-card-content class="pt-16">
      <form (ngSubmit)="sendSms()" [formGroup]="smsForm">
        <!-- Campo fisso: Prefisso e Numero di telefono destinatario -->
        <div class="row" style="flex-wrap: wrap;">
          <div class="col-twenty col-12 col-md-2 mb-3" >
            <grid-input [value]="'0039'">
              <span slot="description">Prefisso</span>
            </grid-input>
          </div>
          <div class="col-forty col-12 col-md-2 mb-3 " >
            <grid-input
              [placeholder]="'N. telefono destinatario'"
              formControlName="telefonoCliente"
            >
              <span slot="description">N. tel. destinatario</span>
            </grid-input>
          </div>
          <div class="col-forty col-12 col-md-2 mb-3">
            <grid-input
              [placeholder]="'es. X12/AAAA/123456789'"
              formControlName="numeroSinistro"
              (valueChange)="onSinistroChange()"
            >
              <span slot="description">Sinistro n.</span>
            </grid-input>
          </div>

        </div>

        <!-- Campo fisso: Numero di telefono liquidatore -->
        <div class="row" style="flex-wrap: wrap;">
          <div class="col-twenty col-12 col-md-2 mb-3" >
            <grid-input [value]="'0039'" [gridDisabled]="true">
              <span slot="description">Prefisso</span>
            </grid-input>
          </div>
          <div class="col-forty col-12 col-md-2 mb-3 ">
            <grid-input
              [placeholder]="'N. telefono liquidatore'"
              formControlName="telefonoLiquidatore"
            >
              <span slot="description">N. tel. liquidatore</span>
            </grid-input>
          </div>
          <div class="col-forty col-12 col-md-2 mb-3 ">
            <grid-input
              [placeholder]="'E-mail liquidatore'"
              formControlName="emailLiquidatore"
            >
              <span slot="description">E-mail liquidatore</span>
            </grid-input>
          </div>
        </div>

        <grid-dropdown
          [gridDisabled]="isCustomText"
          formControlName="smsText"
          [options]="smsTextOptions"
          [placeholder]="'Seleziona un testo SMS...'"
        >
          <span slot="description">Testo SMS</span>
        </grid-dropdown>

        <grid-checkbox formControlName="customTextCheckBox" [hidden]="true"  (checkedChange)="toggleCustomText()">
          <span>Seleziona per inserire un testo personalizzato</span>
        </grid-checkbox>

        <grid-input
          *ngIf="isCustomText"
          [placeholder]="'Testo Personalizzato'"
          formControlName="customText"
          [errorMessage]="'Testo troppo lungo'"
          [isError]="smsForm.get('customText')?.invalid && smsForm.get('customText')?.touched"
        >
          <span slot="description">Testo Personalizzato</span>
        </grid-input>

        <!-- Genera dinamicamente i campi in base ai placeholder trovati -->
        <div *ngFor="let field of dynamicFields">
          <grid-input
            [placeholder]="field"
            [formControlName]="sanitizeFieldName(field)"
          >
            <span slot="description">{{ field }}</span>
          </grid-input>
        </div>

        <!-- Pulsante per inviare il form -->
        <mat-card-actions>
          <grid-button [gridDisabled]="smsForm.invalid" type="submit" class="ml-auto" variant="secondary">Invia
          </grid-button>
        </mat-card-actions>
      </form>

    </mat-card-content>
  </mat-card>
</div>
